(function () {
  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function initGallery(root) {
    const enableLightbox = root.dataset.ppLightbox === "true";
    const filters = qa(root, "[data-pp-filter]");
    const tiles = qa(root, ".pp-gallery__tile");

    // Filtering
    if (filters.length) {
      filters.forEach((btn) => {
        btn.addEventListener("click", () => {
          const key = btn.dataset.ppFilter;
          filters.forEach((b) => {
            b.classList.toggle("is-active", b === btn);
            b.setAttribute("aria-selected", b === btn ? "true" : "false");
          });

          tiles.forEach((tile) => {
            if (key === "all") {
              tile.classList.remove("is-hidden");
              return;
            }
            const tags = (tile.dataset.ppTags || "").split(" ").filter(Boolean);
            tile.classList.toggle("is-hidden", !tags.includes(key));
          });
        });
      });
    }

    // Lightbox
    if (!enableLightbox) return;

    const lightbox = q(root, "[data-pp-lightbox-root]");
    const mediaWrap = q(root, "[data-pp-lightbox-media]");
    const caption = q(root, "[data-pp-lightbox-caption]");
    const closeBtns = qa(root, "[data-pp-close]");
    const openBtns = qa(root, "[data-pp-open]");

    let lastFocus = null;

    function openLightbox(payload) {
      if (!lightbox || !mediaWrap) return;

      lastFocus = document.activeElement;
      mediaWrap.innerHTML = "";
      caption.textContent = payload.title || "";

      if (payload.type === "image" && payload.src) {
        const img = document.createElement("img");
        img.src = payload.src;
        img.alt = payload.title || "Gallery image";
        img.loading = "eager";
        mediaWrap.appendChild(img);
      } else if (payload.type === "video") {
        // If we stored ready-to-insert Shopify video HTML, use it.
        if (payload.videoHtml) {
          mediaWrap.innerHTML = payload.videoHtml;
          const v = mediaWrap.querySelector("video");
          if (v) {
            v.controls = true;
            v.muted = false;
            v.play().catch(() => {});
          }
        } else if (payload.src) {
          // YouTube / Vimeo / MP4
          const s = payload.src.trim();

          if (s.includes("youtube.com") || s.includes("youtu.be")) {
            const id = (s.split("v=")[1] || s.split("/").pop() || "").split("&")[0];
            const iframe = document.createElement("iframe");
            iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;
            iframe.title = payload.title || "Video";
            iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
            iframe.allowFullscreen = true;
            mediaWrap.appendChild(iframe);
          } else if (s.includes("vimeo.com")) {
            const id = s.split("/").pop();
            const iframe = document.createElement("iframe");
            iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1`;
            iframe.title = payload.title || "Video";
            iframe.allow = "autoplay; fullscreen; picture-in-picture";
            iframe.allowFullscreen = true;
            mediaWrap.appendChild(iframe);
          } else {
            const vid = document.createElement("video");
            vid.controls = true;
            vid.playsInline = true;
            vid.preload = "metadata";
            if (payload.poster) vid.poster = payload.poster;
            const source = document.createElement("source");
            source.src = s;
            vid.appendChild(source);
            mediaWrap.appendChild(vid);
            vid.play().catch(() => {});
          }
        }
      }

      lightbox.hidden = false;
      lightbox.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      const closeBtn = q(root, ".pp-gallery__lightboxClose");
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      lightbox.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      mediaWrap.innerHTML = "";
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    }

    openBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        openLightbox({
          type: btn.dataset.ppType,
          src: btn.dataset.ppSrc,
          poster: btn.dataset.ppPoster,
          title: btn.dataset.ppTitle,
          videoHtml: btn.dataset.ppVideoHtml
        });
      });
    });

    closeBtns.forEach((btn) => btn.addEventListener("click", closeLightbox));
    document.addEventListener("keydown", (e) => {
      if (!lightbox || lightbox.hidden) return;
      if (e.key === "Escape") closeLightbox();
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-pp-gallery]").forEach(initGallery);
  });
})();
